import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "container",
  class: "p-invitation"
}
const _hoisted_2 = { class: "p-invitation__btn-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "p-invitation__title a-font__h1" }, " Пригласить друга ", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "p-invitation__txt a-font__l" }, " Выбери один из вариантов для приглашения: ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BaseButton, {
        class: "m_w311 mm_w100p",
        onClick: _ctx.invitePage
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Онлайн-анкета ")
        ])),
        _: 1,
        __: [0]
      }, 8, ["onClick"])
    ])
  ], 512))
}